<template>
<v-col id="newShipmentID" ref="newShipmentRef" class="planner-layout__add disableDrag">
    <v-container class="pt-0 pl-1 pr-1 pb-1">
        <v-card flat color="transparent">
          <v-card-title>
            <v-btn
            @click="addNewShipmentInPlannerDoc"
            class="ml-2 mr-0"
            small
            fab
            color="#028489"
            :disabled="getIsCreatingShipment"
            >
              <v-icon
                v-if="!getIsCreatingShipment"
                color="white"
              >
                add
              </v-icon>
              <v-progress-circular
                v-if="getIsCreatingShipment"
                size="20"
                width="3"
                indeterminate
                color="white"
              />
            </v-btn>
            <v-btn @click="handleSavePlanner" class="ml-2 mr-0" small fab color="#028489">
              <v-icon color="white">
                save
              </v-icon>
            </v-btn>
            <v-btn
            @click="handleDatePicker" class="ml-2 mr-0" small fab color="#028489"
            id="planner-date-picker"
            >
              <v-icon color="white">
                fas fa-calendar-alt
              </v-icon>
            </v-btn>
            <ExportPlanner />
          </v-card-title>
        </v-card>
    </v-container>
</v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import 'litepicker/dist/css/style.css'
import Litepicker from 'litepicker'
import ExportPlanner from '@/components/planner/ExportPlanner.vue'

export default {
  name: 'ShipmentActions',
  components: {
    ExportPlanner
  },
  data() {
    return {
      picker: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.picker = new Litepicker({
        element: document.getElementById('planner-date-picker'),
        singleMode: true,
        lang: this.$i18n.locale,
        onSelect: (date) => (this.handleChangePlannerDay.apply(null, [date]))
      })
      this.picker.hide()
    })
  },
  methods: {
    ...mapActions({
      setPlannerNewShipment: 'setPlannerNewShipment',
      savePlanner: 'savePlanner',
      newPlannerDoc: 'newPlannerDoc',
      setVisibleShipments: 'setVisibleShipments'
    }),
    addNewShipmentInPlannerDoc () {
      this.setPlannerNewShipment({ doc: this.getPlannerDoc })
    },
    handleSavePlanner () {
      const day = this.$route.query.day
      const shipmentIDs = this.$route.query.shipmentIDs
      let dropIDs = []
      let shipmentIDsArray = []
      if (Array.isArray(shipmentIDs)) {
        shipmentIDsArray = shipmentIDs
      } else {
        shipmentIDsArray = [shipmentIDs]
      }
      shipmentIDsArray.forEach((shipmentID) => {
        dropIDs = [...dropIDs, ...this.getPlannerDropsByShipmentID(shipmentID)]
      })
      this.savePlanner({ doc: this.getPlannerDoc, docDay: day, shipmentIDs, dropIDs})
    },
    handleDatePicker () {
      this.picker.show()
    },
    handleChangePlannerDay (date) {
      // let plannerDay = moment(date).utc(true).startOf('day').unix()
      moment.tz.setDefault(moment.tz.guess())
      let plannerDay = moment(date).utc(true).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).unix()
      this.$router.push({ path: `planner?day=${plannerDay}` })
      this.setVisibleShipments({ shipmentIDs: [] })
      this.newPlannerDoc({ docDay: plannerDay, shipments: [] })
    }
  },
  computed: {
    ...mapGetters([
      'getPlannerDoc',
      'getPlannerVisibleShipments',
      'getPlannerDropsByShipmentID',
      'getIsCreatingShipment'
    ])
  },
  watch: {
    getPlannerVisibleShipments: {
      deep: true,
      handler (val, oldVal) {
        if (val != null) {
          if (val.length > 1) {
            const query = { ...this.$route.query, shipmentIDs: val}
            this.$router.push({ path: '/planner', query })
          } else if (val.length ===  1) {
            const query = { ...this.$route.query, shipmentIDs: val[0]}
            this.$router.push({ path: '/planner', query })
          }
        }
      }
    },
    '$i18n.locale': {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (oldVal !== val && this.picker != null) {
          this.picker.setOptions({ lang: val })
        }
      }
    }
  },
  beforeDestroy() {
    this.picker.destroy()
  },
}
</script>

<style lang="scss" scoped>
  .v-card__title {
    button {
      margin: 0 auto;
    }
  }
</style>
